const reconnectTimeouts = [1000, 2000, 5000, 10000, 30000, 120000];

const reconnectTimeoutIndex: {
  [key: string]: number;
} = {};

const reconnectTimers: {
  [key: string]: number[];
} = {};

export const postponeReconnect = (key: string, reconnect: () => void) => {
  reconnectTimeoutIndex[key] ??= 0;
  const timeout = reconnectTimeouts[reconnectTimeoutIndex[key]];
  if (reconnectTimeoutIndex[key] < reconnectTimeouts.length - 1) {
    reconnectTimeoutIndex[key] += 1;
  }
  const timerId = window.setTimeout(() => {
    reconnect();
  }, timeout);
  reconnectTimers[key] ??= [];
  reconnectTimers[key].push(timerId);
};

export const clearReconnect = (key: string) => {
  if (reconnectTimers[key]) {
    for (const timerId of reconnectTimers[key]) {
      window.clearTimeout(timerId);
    }
    reconnectTimers[key] = [];
  }
  reconnectTimeoutIndex[key] = 0;
};
